import { render, staticRenderFns } from "./DocumentChat.vue?vue&type=template&id=1309ee54&scoped=true"
import script from "./DocumentChat.vue?vue&type=script&lang=js"
export * from "./DocumentChat.vue?vue&type=script&lang=js"
import style0 from "./DocumentChat.vue?vue&type=style&index=0&id=1309ee54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1309ee54",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AlturaContainer: require('/app/node_modules/@altura/components/components/Container.vue').default,FileIcon: require('/app/components/FileIcon.vue').default,AlturaListItem: require('/app/node_modules/@altura/components/components/list/ListItem.vue').default,AlturaSelect: require('/app/node_modules/@altura/components/components/Select.vue').default,AlturaSpinner: require('/app/node_modules/@altura/components/components/Spinner.vue').default,AlturaIcon: require('/app/node_modules/@altura/components/components/Icon.vue').default,AlturaProfilePicture: require('/app/node_modules/@altura/components/components/ProfilePicture.vue').default,AlturaText: require('/app/node_modules/@altura/components/components/Text.vue').default,AlturaToggleButton: require('/app/node_modules/@altura/components/components/ToggleButton.vue').default,AlturaTextbox: require('/app/node_modules/@altura/components/components/Textbox.vue').default,AlturaButton: require('/app/node_modules/@altura/components/components/Button.vue').default,AlturaPaginator: require('/app/node_modules/@altura/components/components/Paginator.vue').default,AlturaAccordionItem: require('/app/node_modules/@altura/components/components/accordion/AccordionItem.vue').default,AlturaAccordion: require('/app/node_modules/@altura/components/components/accordion/Accordion.vue').default})
